/* 186 (c) [RULED 186 (16)] — ONE SEARCH FIELD ON THREE SECTIONS. The search
 * box the Notes section carried since 186 B.6 — the agenda header's own
 * `.search-box` at 240 wide with the 12px Search icon and
 * `common.search_placeholder` — moved here once, character for character, so
 * Notes, the Chronology and Stages render the same field from the same
 * markup. The predicate stays with each section: what a section searches is
 * its own rows and its own columns; the FIELD is shared.
 *
 * EXTRACT, DON'T IMPROVE: the wrapper row, the class, the width, the icon and
 * the placeholder are the Notes section's own. A caller hands the query in and
 * takes the typed value back.
 */
import React from "react";
import type { Dispatch } from "react";
import { Search } from "lucide-react";
import { useTranslation } from "../i18n";
import type { Translate } from "../lib/interestRefusal";

interface Props {
  value: string;
  /** Typed by React's `Dispatch`: a function type with a named parameter is a
   *  `no-unused-vars` warning in a file outside the eslint baseline. */
  onChange: Dispatch<string>;
}

export default function SectionSearch({ value, onChange }: Readonly<Props>) {
  const { t } = useTranslation() as { t: Translate };
  return (
    <div style={{ display: "flex", alignItems: "center", margin: "4px 0 6px" }}>
      <div className="search-box" style={{ width: 240 }}>
        <Search size={12} style={{ color: "var(--tm)", flexShrink: 0 }} />
        <input
          placeholder={t("common.search_placeholder", { fallback: "Search…" })}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
